import { render, staticRenderFns } from "./SharedTableSkeleton.vue?vue&type=template&id=fc3aaf8a&scoped=true"
import script from "./SharedTableSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedTableSkeleton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SharedTableSkeleton.vue?vue&type=style&index=0&id=fc3aaf8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3aaf8a",
  null
  
)

export default component.exports